import {
	Box,
	FormControl,
	Typography,
	InputLabel,
	Select,
	MenuItem,
	TextField,
	Grid,
	InputAdornment,
	Chip,
	Checkbox,
	FormControlLabel,
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import EditIcon from "@mui/icons-material/Edit";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import React, { useEffect }  from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { getDataSources, setState,getCustGrpRef,clearData } from "../scenarioSetupNewSlice";
import { width } from "@mui/system";

const commonHeight = sizes.h35;

export default function ScenarioInfoForm() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const loginState = useSelector((store) => store.login);
	const {
		countries,
		selectedCountry,
		scenarioName,
		periodType,
		periodTypes,
		createFromDate,
		createToDate,
		sentToSAP,
		countryID,
		predictionMethodPeriodList,
		previousYearPeriodList,
		DefaultInitialForecast
	} = setupState;
	const { globalSelectedCountryName,globalSelectedCountryID,} = loginState
	const minSelectableDate = new Date();
	//const minSelectableDate = dayjs().startOf("month").toDate();
	const y = minSelectableDate.getFullYear();
	const m = minSelectableDate.getMonth() + 1 < 10 ? `0${minSelectableDate.getMonth() + 1}` : minSelectableDate.getMonth() + 1;
	const d = "01";
	const minDate = `${y}-${m}-${d}`;

	useEffect(() => {
		if(globalSelectedCountryID !== null){
		if(countryID !== globalSelectedCountryID)clearData();
		dispatch(setState("countryID", globalSelectedCountryID));
		}
	},[globalSelectedCountryID])

	useEffect(() => {
		if(globalSelectedCountryName !== null && globalSelectedCountryName !== ""){
		dispatch(setState("selectedCountry", globalSelectedCountryName));
		}
	},[globalSelectedCountryName])

	const handleCountryChange = (event) => {
		clearData();
		const countryName = event.target.value;
		const countryId = countries.find(
			(country) => country.countryName === countryName
		).countryID;
		dispatch(setState("selectedCountry", countryName));
		dispatch(setState("countryID", countryId));

		clearCountryDependents();
		getCountryDependents(countryId);
	};

	const clearCountryDependents = () => {
		dispatch(setState("dataSources", []));
		dispatch(setState("selectedDSs", []));
	};

	const getCountryDependents = (countryID) => {
		dispatch(getDataSources({ countryID }));
		dispatch(getCustGrpRef({countryID}));
	};

	const validFromDate = (date) => {
		if (periodType.length <= 0) {
			showMessage("Please select period type first", "info");
			return false;
		}
		if (periodType === "Weekly" && date.day() !== 1) {
			showMessage(
				"Chosen day must be Monday for weekly period type",
				"info"
			);
			return false;
		}
		if (periodType === "Monthly" && date.date() !== 1) {
			showMessage(
				"Chosen day must be first day of month for monthly period type",
				"info"
			);
			return false;
		}
		if (date < dayjs() && periodType === "Weekly" && date.day() !== 1) {
			showMessage("Past dates cannot be selected", "info");
			return false;
		}
		if (date < dayjs() && periodType === "Monthly" && date.date() !== 1) {
			showMessage("Past dates cannot be selected", "info");
			return false;
		}
		if (date > createToDate) {
			showMessage("Invalid from date", "info");
			return false;
		}
		return true;
	};

	const validToDate = (date) => {
		if (periodType.length <= 0) {
			showMessage("Please select period type first", "info");
			return false;
		}
		if (periodType === "Weekly" && date.day() !== 0) {
			showMessage(
				"Chosen day must be Sunday for weekly period type",
				"info"
			);
			return false;
		}
		if (
			periodType === "Monthly" &&
			!date.isSame(date.endOf("month"), "day")
		) {
			showMessage(
				"Chosen day must be last day of month for monthly period type",
				"info"
			);
			return false;
		}
		if (date < dayjs()) {
			showMessage("Past dates cannot be selected", "info");
			return false;
		}
		if (date < createFromDate) {
			showMessage("Invalid from date", "info");
			return false;
		}
		return true;
	};

	const handleCreateFromDate = (newDate) => {
		validFromDate(newDate);
		dispatch(setState("createFromDate", newDate));
		
	};

	const handleCreateToDate = (newDate) => {
		validToDate(newDate);
		dispatch(setState("createToDate", newDate));
	};

	const handleScenarioName = (event) => {
		const pattern = /^[a-zA-Z0-9 ]*$/;
		if (event.target.value == " ") {
		  event.target.value = event.target.value.replace(" ", "");
		}
		else if (event.target.value.startsWith(" ")) {
		  event.target.value = event.target.value.trimStart();
		}
		if (!pattern.test(event.target.value)) {
		  event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, "");	
		}
		if (selectedCountry.length <= 0) {
			showMessage("Please select a country first", "info");
			return;
		}
		const value = event.target.value;
		dispatch(setState("scenarioName", value));
	};

	const handlePeriodType = (event) => {
		if (scenarioName.length <= 0) {
			showMessage("Please enter scenario name first", "info");
			return;
		}
		const value = event.target.value;
		dispatch(setState("periodType", value));
	};

	const handleCheckedUpdate = (event, stateName) => {
		const option = event.target.checked;
		dispatch(setState(stateName, option));
	};

	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};
	 const clearData = () =>{
		dispatch(setState("isLoading", false));
		dispatch(setState("isCopyScenario", false));
		dispatch(setState("sku_PG_Name", ""));
		dispatch(setState("productGroups", []));
		dispatch(setState("selectedPGs", []));
		dispatch(setState("selectedcustomerTypes", []));
		dispatch(setState("selectedCustType", ""));
		dispatch(setState("selectedCTCode", ""));
		dispatch(setState("selectedCL", ""));
		dispatch(setState("selectedCLID", ""));
		dispatch(setState("breakDowns", []));
		dispatch(setState("selectedBD", ""));
		dispatch(setState("breakDownTypes", []));
		dispatch(setState("selectedBDT", ""));
		dispatch(setState("selectedTL", "All"));
		dispatch(setState("selectedTLID", 0));
		dispatch(setState("customerName", ""));
		dispatch(setState("custsCGs", []));
		dispatch(setState("selectedCustsCGs", []));
		dispatch(setState("selectedDSs", []));
		dispatch(setState("selectedPDS", ""));
		dispatch(setState("selectedSKUBDM", ""));
		dispatch(setState("selectedScSTQ", "Disabled"));
		dispatch(setState("selectedScUB", "Disabled"));
    	dispatch(setState("selectedScModifySTQ", "Disabled"));
		dispatch(setState("selectedPG_SKU_ADSs",""));
		dispatch(setState("selectedPG_SKU_ADSsID", ""));
		dispatch(setState("DSAData", []));
		dispatch(setState("scDSA", []));
		dispatch(setState("scDSACopy", []));
		dispatch(setState("DSAIdString", ""));
		dispatch(setState("DSAIdStringPrev", ""));
		dispatch(setState("skuBreakdown", ""));
		dispatch(setState("customerBreakdownType", "Scenario SKUs"));
		dispatch(setState("customerBreakdown", "Internal 3 months"));
		dispatch(setState("MarketShareTimePeriod", ""));
		dispatch(setState("PreviousMarketShareTimePeriod", ""));
		dispatch(setState("scenarioName", ""));
		// api payload for scenario
		dispatch(setState("primaryDataSourceID", ""));
		dispatch(setState("minimumQuota", ""));
		dispatch(setState("comments", ""));
		dispatch(setState("lstScenarioCustomers", ""));
		dispatch(setState("lstScenarioCustomerGroups", ""));
		dispatch(setState("lstScenarioSKUs", ""));
		dispatch(setState("lstScenarioProducts", ""));
		dispatch(setState("scenarioDataSourceAlignment", []));
		dispatch(setState("scenarioStatus", ""));
		dispatch(setState("editScName", ""));
		dispatch(setState("editScenarioList", []));
		dispatch(setState("editScID", ""));
		dispatch(setState("editScDetails", null));
		dispatch(setState("message", ""));
		dispatch(setState("severity", ""));
		dispatch(setState("messageOpen", ""));
		dispatch(setState("selectedLinearTrend", predictionMethodPeriodList[0]?.name));
		dispatch(setState("selectedRunRate", predictionMethodPeriodList[0]?.name));
		dispatch(setState("selectedConsensus", predictionMethodPeriodList[0]?.name));
		dispatch(setState("selectedPreviousYear", previousYearPeriodList[0]?.name));
		dispatch(setState("selectedDefaultInitialForecast", DefaultInitialForecast[1]?.name));
		dispatch(setState("editScDSAData", []));
		dispatch(setState("localForecastAlignment", []));
		dispatch(setState("periodType", ""));
		dispatch(setState("criticalityId", ""));
		dispatch(setState("SafetyMargin",[]));
		//dispatch(setState("SafetyMargin",[{type: "Customer Group", safetyMargin: '', typeCode: "CustomerGroup"}],));
		dispatch(setState("selectedReferenceSKU", []));
		dispatch(setState("previousSelectedReferenceSKU", []));
		dispatch(setState("marketShareComparisonList", []));
		dispatch(setState("previousMarketShareComparisonList", []));
		dispatch(setState("selectedRows", []));
		dispatch(setState("marketShareGraphData", []));
		dispatch(setState("previousMarketShareGraphData", []));
		dispatch(setState("manually_defineMSList", []));
		dispatch(setState("quotaDeviationPercentage", 0));
		dispatch(setState("modificationDeviationPercentage", 0));
		dispatch(setState("scenarioExternalDataSource", []));
		dispatch(setState("scenarioExternalDataSourceSKU", []));
		dispatch(setState("refList",''));
		dispatch(setState("selectedCCID", 0));
		dispatch(setState("selectedCustCat", "All"));
		dispatch(setState("selectedCountry", ""));
		dispatch(setState("countryID", ""));
		dispatch(setState("openScenarioPopUp", false));
		dispatch(setState("errorMessage", ""));
		dispatch(setState("errorList", []));
		dispatch(setState("createToDate", dayjs("2099-12-31")));
		dispatch(setState("createFromDate", null));
		dispatch(setState("section_Scenario_Parameteres", false));
		dispatch(setState("section_SKU", false));
		dispatch(setState("section_Customer", false));
		dispatch(setState("section_Datasources", false));
		dispatch(setState("section_Scenario_Settings", false));
		dispatch(setState("is_Refresh", true));
		dispatch(setState("isCustomerChanged", false));
	}
	

	return (
		<Box sx={{mt:4,}}>
			<Grid container columns={12} columnSpacing={3} rowSpacing={3} justifyContent={"space-between"}>
				<Grid item md={2}>
					<Box sx={{ mt: 0 }}>
						<FormControl sx={{width: "100%"}}>
							<InputLabel id="demo-simple-select-label">
								Country
							</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={selectedCountry}
								label="Country"
								sx={{
									height: commonHeight,
									width: sizes.w300,
									color: "black.main.main",
									mt: 1,
								}}
								onChange={handleCountryChange}
							>
								{countries.map((country, index) => {
									return (
										<MenuItem value={country.countryName} key={index}>
											{country.countryName}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>
				<Grid item sm={2.5}>
					<Box>
						<TextField sx={{width:"100%"}}
							id="input-with-icon-textfield"
							label="Scenario Name"
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<EditIcon />
									</InputAdornment>
								),
							}}
							variant="standard"
							// sx={{
							// 	width: sizes.w300,
							// }}
							value={scenarioName}
							onChange={handleScenarioName}
						/>
					</Box>
				</Grid>

				<Grid md={2} item>
					<Box >
						<FormControl sx={{width:"100%"}}>
							<InputLabel id="demo-simple-select-label">
								Period Type
							</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={periodType}
								label="Period Type"
								sx={{
									height: commonHeight,
									width: sizes.w300,
									color: "black.main.main.main",
									mt: 1,
								}}
								onChange={handlePeriodType}
							>
								{periodTypes.map((type, index) => {
									return (
										<MenuItem value={type.name} key={index}>
											{type.name}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>

				<Grid md={2} item>
					<Box>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker sx={{width:"100%"}}
								// minDate={minSelectableDate}
								minDate={dayjs(minDate)}
								label="From"
								value={createFromDate}
								onChange={(newValue) => handleCreateFromDate(newValue)}
								renderInput={(params) => (
									<TextField
										{...params}
										size="small"
									/>
								)}
								format="DD/MM/YYYY"
							/>
						</LocalizationProvider>
					</Box>
				</Grid>
				<Grid item md={2}>
					<Box>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker sx={{width:"100%"}}
								// minDate={minSelectableDate}
								minDate={dayjs(minDate)}
								label="To"
								value={createToDate}
								onChange={(newValue) => handleCreateToDate(newValue)}
								renderInput={(params) => (
									<TextField
										{...params}
										size="small"
									/>
								)}
								format="DD/MM/YYYY"
							/>
						</LocalizationProvider>
					</Box>
				</Grid>

				<Grid item md={1.5}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
						}}
					>
						<FormControlLabel
							control={
								<Checkbox
									checked={sentToSAP}
									onChange={(event) =>
										handleCheckedUpdate(event, "sentToSAP")
									}
									inputProps={{ "aria-label": "controlled" }}
									sx={{ ml: 1 }}
								/>
							}
						/>

						<Typography variant="subtitle2" sx={{ mt: 1.5, fontSize: 14, ml: -2,}}>
							Send to SAP
						</Typography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}
